<!--
  ~ Copyright (c) 1999 - 2021 Accorto, Inc. - All rights reserved.
  -->

<div aria-hidden="false"
     attr.aria-label="Date picker: {{monthName}}"
     [ngClass]="align"
     class="slds-datepicker slds-dropdown"
     role="dialog">
  <form [formGroup]="dateForm"
        class="slds-datepicker__filter slds-grid">
    <!-- month -->
    <div class="slds-datepicker__filter_month slds-grid slds-grid_align-spread slds-grow">
      <div class="slds-align-middle">
        <button (click)="onPreviousMonth($event)"
                class="slds-button slds-button_icon slds-button_icon-container"
                id="pick-month-prev"
                i18n-title title="Previous Month">
          <svg aria-hidden="true" class="slds-button__icon">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#left"
                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
          </svg>
          <span class="slds-assistive-text" i18n>Previous Month</span>
        </button>
      </div>
      <h2 aria-atomic="true" aria-live="assertive" class="slds-align-middle"
          id="pick-month">{{monthName}}</h2>
      <div class="slds-align-middle">
        <button (click)="onNextMonth($event)"
                class="slds-button slds-button_icon slds-button_icon-container"
                id="pick-month-next"
                i18n-title title="Next Month">
          <svg aria-hidden="true" class="slds-button__icon">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#right"
                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
          </svg>
          <span class="slds-assistive-text" i18n>Next Month</span>
        </button>
      </div>
    </div>
    <!-- year -->
    <div class="slds-shrink-none">
      <label class="slds-assistive-text" for="pick-year" i18n>Pick a Year</label>
      <div class="slds-select_container">
        <select #yearSelect (change)="onYearChange(yearSelect.value)"
                formControlName="year"
                class="slds-select"
                id="pick-year">
          <option *ngFor="let yy of years" [value]="yy">
            {{yy}}
          </option>
        </select>
      </div>
    </div>
  </form>

  <table aria-labelledby="month" class="slds-datepicker__month" role="grid">
    <thead>
    <tr id="pick-weekdays">
      <th *ngFor="let wd of weekDays"
          [id]="wd.title"
          scope="col">
        <abbr title="{{wd.title}}">{{wd.abbr}}</abbr>
      </th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let week of weeks; index as iw">
      <td *ngFor="let day of week.days; index as id"
          [attr.aria-disabled]="day.disabled"
          [attr.aria-selected]="day.selected"
          [ngClass]="day.cssClass"
          class="cal-day"
          role="gridcell">
        <span (click)="onDayClick($event, day)"
              id="pick-day-{{iw}}-{{id}}"
              class="slds-day">{{day.title}}</span>
      </td>
    </tr>
    <tr>
      <td colspan="7" role="gridcell">
        <span (click)="onToday()"
              class="slds-show_inline-block slds-text-link slds-p-bottom_x-small"
              id="pick-today"
              i18n
              style="cursor: pointer">Today
        </span>
        <button (click)="onClear()"
                class="slds-button slds-button_icon slds-float_right"
                id="pick-clear"
                title="Clear">
          <svg aria-hidden="true" class="slds-button__icon">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#clear"></use>
          </svg>
          <span class="slds-assistive-text">Clear</span>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
